module.exports = __webpack_public_path__ + "images/guide-front-dark.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guide-front-dark.png
// module id = 1059
// module chunks = 17